var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0913 0H0.818202C0.366336 0 0 0.366336 0 0.818202V4.09101C0 4.32158 0.0972569 4.5414 0.267825 4.69648L6.00015 9.90722V17.1818C6.00015 17.4654 6.14693 17.7287 6.38814 17.8778C6.51959 17.959 6.66873 18 6.81835 18C6.94342 18 7.06883 17.9714 7.18425 17.9136L10.4571 16.2772C10.7343 16.1386 10.9094 15.8553 10.9094 15.5454V9.90722L16.6417 4.69648C16.8122 4.5414 16.9095 4.32158 16.9095 4.09101V0.818202C16.9095 0.366336 16.5432 0 16.0913 0ZM9.54078 8.93984C9.37021 9.09491 9.27295 9.31473 9.27295 9.5453V15.0398L7.63655 15.858V9.5453C7.63655 9.31473 7.53929 9.09491 7.36872 8.93984L2.93467 4.90921H13.9748L9.54078 8.93984ZM15.2731 3.27281H1.6364V1.6364H15.2731V3.27281Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.a938a59d25da68ef5899152fd2580354.svg";
export { ForwardRef as ReactComponent };